<ion-content slot="center">
  <div class="content-wrapper">
    <form class="login-form-container">
      <div class="main-logo" (click)="moveToHome()">
        <img
          src="../../../../assets/icon-only.png"
          alt="logo"
          class="logo"
        />
      </div>
      
      <div class="login-title">
        <div class="brand-name"><span class="skill">Skill</span><span class="mantra">Mantra</span></div>
        <span class="login-subtitle" routerLink="/home">{{loginContent[0]}}</span>
      </div>
      
      <!-- <div class="login-tabs">
        <div 
          [class.active]="loginType === 'otp'" 
          class="tab-item" 
          (click)="loginType = 'otp'">
          Using OTP
        </div>
        <div 
          [class.active]="loginType === 'username-password'" 
          class="tab-item" 
          (click)="loginType = 'username-password'">
          Using Password
        </div>
      </div> -->

      <ng-container *ngIf="loginType === 'otp'">
        <app-mobile-otp></app-mobile-otp>
      </ng-container>

      <ng-container *ngIf="loginType === 'username-password'">
        <app-email-otp></app-email-otp>
      </ng-container>

      <!-- <div class="signup-text-container">
        <p class="signup-text" (click)="loginType = loginType === 'otp' ? 'username-password' : 'otp'">{{loginContent[1]}} {{loginType === 'otp' ? 'Password' : 'OTP'}}</p>
        <p class="signup-text" routerLink="/signup">{{loginContent[2]}}</p>
      </div> -->
      
      <div class="separator">
        <span>OR</span>
      </div>
      
      <div class="samhita-login">
        <button (click)="loginWithSamhita()" class="samhita-button">
          <img height="30"  src="../../../../assets/images/samhita_sso.png" alt="Samhita Logo" />
          <span class="samhita-text">Samhita AuthSam</span>
        </button>
      </div>
    </form>
  </div>
</ion-content>